import {
  DimConfiguration,
  FollowUpConfiguration
} from "shared/types/__generated__/graphql"

import {
  DimConfigurationTypename,
  FollowUpConfigurationTypename
} from "../../dim-configuration/types/FollowUpConfiguration"

type PatchableDimConfiguration = Omit<DimConfiguration, "__typename">

type PatchableFollowUpConfiguration = Omit<
  FollowUpConfiguration,
  "__typename" | "sourceProduct" | "targetProduct"
> & {
  sourceProduct: PatchableDimConfiguration
  targetProduct: PatchableDimConfiguration
}

export function patchFollowUpConfigurationType(
  data: PatchableFollowUpConfiguration
): FollowUpConfiguration {
  return {
    ...data,
    __typename: FollowUpConfigurationTypename,
    sourceProduct: {
      ...data.sourceProduct,
      __typename: DimConfigurationTypename
    },
    targetProduct: {
      ...data.targetProduct,
      __typename: DimConfigurationTypename
    }
  }
}
